import React from 'react';
import { Link, Row, Col } from '@flightstats/airframe-react';

import {
  TripGroupView,
  EmailConfigurationView,
} from '../../types/tripGroup';
import { FormLabeledInputRowWrapper } from '../../components/forms/Input';
import MessageConfigTripGroupDropdown from '../components/messageConfigTripGroupDropdown';
import type { MessageConfiguration } from '../../types/messageConfiguration';
import { NewTabIcon } from '../components/styledComponent';
import { StyledSwitch } from '../../components/forms/Switch';

interface TripGroupEmailConfigurationProps {
  tripGroupView?: TripGroupView;
  emailConfig?: EmailConfigurationView;
  messageConfigs: MessageConfiguration[];
  onSelect: (value: string) => void;
  isOverridden: boolean;
  setIsOverridden: (value: boolean) => void;
  labelType: string;
  isDisabled: boolean;
}

export const TripGroupEmailConfiguration: React.FC<TripGroupEmailConfigurationProps> = ({
  tripGroupView,
  emailConfig,
  messageConfigs,
  onSelect,
  isOverridden,
  setIsOverridden,
  labelType,
  isDisabled,
}) => {
  let messageConfigsCopy = messageConfigs;
  if (!emailConfig && messageConfigs.length) {
    const dropDownOption = {
      name: '<Select a value>',
      id: 'none',
    };
    messageConfigsCopy = [dropDownOption, ...messageConfigs];
  }

  return (
    <>
      <Row>
        <Col>
          <h4>{labelType} Alert Email Configuration</h4>
        </Col>
        <Col align={'flex-end'}>
          <StyledSwitch
            text={`Customize ${labelType} Email Configuration`}
            name={`${tripGroupView?.id || ''}CustomOverride`}
            on={isOverridden}
            onChange={setIsOverridden}
            textRight={false}
            isDisabled={isDisabled}
          />
        </Col>
      </Row>

      {!isOverridden && tripGroupView ? (
        <p data-fs-exclude>
          Inheriting Email Configuration from{' '}
          <Link href={`/tripGroups/${tripGroupView.id}`}>
            {tripGroupView.lineage} ({tripGroupView.tripGroupViewSettings.name})
          </Link>
        </p>
      ) : isOverridden && messageConfigs.length ? (
          <>
            <FormLabeledInputRowWrapper
              elementId="emailConfig"
              label="Selected Email Configuration:"
              width="200px"
            >
              <MessageConfigTripGroupDropdown
                id="emailConfig"
                onSelect={onSelect}
                value={emailConfig?.id}
                messageConfigs={messageConfigsCopy}
              />
            </FormLabeledInputRowWrapper>
            {emailConfig && (
              <Link
                className='message-configuration-link'
                href={`/messageConfiguration/${emailConfig.id}`}
                target="_blank"
              >
                {messageConfigs.find(m => m.id === emailConfig.id)?.name}
                {NewTabIcon}
              </Link>
            )}
          </>
        ) : (
          <p>
            No Email Configuration Specified.{' '}
            {!messageConfigs.length && (
              <>
                Create a default email configuration{' '}
                <Link href="/messageConfiguration">here</Link> before editing
                the settings of this page
              </>
            )}
          </p>
        )}
    </>
  );
};
